<template>
  <div class="form-container" id="confirm">
    <div class="sectionHeader">
      {{ $t('identification.lblHeader') }}
    </div>
    <div class="sectionheader">
      <p>{{ $t('identification.lblMessage1') }}<br>{{ $t('identification.lblMessage2') }}</p>
      <p>{{ $t('identification.lblMessage3') }}
        <a href="https://www.shinseibank.com/powerflex/newpd/" target="_blank">{{ $t('identification.lblMessage4') }}</a>
        {{ $t('identification.lblMessage5') }}
        <a href="https://faq.shinseibank.com/faq_detail.html?id=223&page=1&intcid=AuthChat" target="_blank">{{ $t('identification.lblMessage6') }}</a>
      </p>
      <p>{{ $t('identification.lblMessage7') }}</p>
    </div>
    <form @submit.prevent="exec">
      <div class="form-group">
        <div class="form-label">
          <label for="inputPID">{{ $t('identification.lblAccountNumber') }}</label>
        </div>
        <input
          v-model="form.pid"
          type="text"
          class="form-control"
          id="inputPID"
          :placeholder="$t('identification.placeholderAccountNumber')"
          maxlength="10"
          pattern="^[0-9]+"
          required>
      </div>
      <div class="form-group">
        <div class="form-label">
          <label for="inputPIN">{{ $t('identification.lblPinCode') }}</label>
        </div>
        <input
          v-model="form.pin"
          type="password"
          class="form-control"
          id="inputPIN"
          :placeholder="$t('identification.placeholderPinCode')"
          maxlength="4"
          pattern="^[0-9]+"
          required>
      </div>
      <div class="form-group">
        <div class="form-label">
          <label for="inputBirth">{{ $t('identification.lblBirth') }}</label>
        </div>
        <input
          v-model="form.birth"
          type="text"
          class="form-control"
          id="inputBirth"
          :placeholder="$t('identification.placeholderBirth')"
          maxlength="4"
          pattern="^[0-9]+"
          required>
      </div>
      <div slot="footer" class="message">
        {{message}}
      </div>
      <div slot="footer" class="validMsg" v-html=errorMessage>
      </div>
      <div class="btn-container">
        <button type="submit" class="btn btn-primary"
          v-bind:class="{ 'btn-disabled': isDisabled}"
          v-bind:disabled="isDisabled"      
        >{{ $t('app.btnNext') }}</button>
      </div>
    </form>
    <div class="link-container">
      <router-link :to="{ path:'login', query: $route.query}">{{$t('identification.lblLogin')}}</router-link>
    </div>
  </div>
</template>

<script>
import { identification } from '@/lib/api/commb-api'
export default {
  name: 'identification',
  data: function () {
    return {
      form: {
        pid: '',
        pin: '',
        birth: ''
      },
      message: '',
      errorMessage: '',
      isDisabled: false
    }
  },
  async beforeCreate() {
    this.$router.push({ path: 'onetime-input', query: this.$route.query}).catch(() => {})
  },
  methods: {
    async exec () {
      this.isDisabled = true;
      const { pid, pin, birth } = this.form;
      const lang = ['ja', 'en'].includes(this.$route.query.lang) ? this.$route.query.lang : 'ja'
      this.message = '';
      this.errorMessage = '';
      await identification(pid, pin, birth, lang)
        .then(() => this.$router.push({ path: 'login' , query: this.$route.query}))
        .catch(error => {
          this.errorMessage = error ? error : this.$i18n.t('app.errorMessage');
        });
      this.isDisabled = false;
    }
  }
}
</script>
